import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import PageSkeleton from '../../components/PageSkeleton';
import LoadingPageError from '../../components/LoadingPageError';
const PublicLessonPageLoadable = Loadable({
  loader: () => import( /* webpackChunkName: "PublicLessonPage" */'../PublicLessonPage'),
  LoadingComponent: PageSkeleton,
  ErrorComponent: LoadingPageError
});
export default PublicLessonPageLoadable;